module.exports = __webpack_public_path__ + "static/media/google-calendar.efe17fa6.png";